(function () {
  'use strict';

  angular
    .module('web2print')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig ($stateProvider, $urlRouterProvider) {
    console.log('App routes');
    $stateProvider
      .state('main', {
        abstract: true,
        url: '?toggleFeatures',
        templateUrl: 'components/layout/base.html',
        controller: 'MainController',
        controllerAs: 'main',
        onEnter: function (Common, $state, $rootScope, $location) {
          Common.getUserProfile($rootScope.isNCPUser());
          Common.checkUserTypeAndOrder($rootScope.isNCPUser());

          if (Common.get('pageBeforeLogin', false)) {
            $location.path(Common.get('pageBeforeLogin'));
            Common.set('pageBeforeLogin', null);
          }
        }
      });

    $urlRouterProvider.otherwise('/information');
  }

})();
